// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ee942e98","453":"419b5d2c"}[chunkId] + ".chunk.js";
};